<template>
    <div class="container">
        <div class="col-md-12">
            <div class="loading">
                <img src="../../public/img/loading.gif">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loading'
}
</script>

<style>
.loading img{
    display: block;
    margin-left: auto;
    margin-right: auto;
}    
</style>